import { render, staticRenderFns } from "./Webhooks.vue?vue&type=template&id=2988a816&"
import script from "./Webhooks.vue?vue&type=script&lang=js&"
export * from "./Webhooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports